import { memo } from 'react';
import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';

interface TwitterIconProps extends IconWrapperProps {
  backFillColor: string;
  frontFillColor: string;
}

const TwitterIcon = ({ backFillColor, frontFillColor, ...rest }: TwitterIconProps) => (
  <span>
    <IconWrapper width="40px" viewBox="0 0 40 40" title="X Link" {...rest}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g>
          <rect fill={backFillColor} x="0" y="0" width="40" height="40" rx="20" />
          <g
            transform="translate(9.000000, 9.000000) scale(0.75)"
            fill={frontFillColor}
            fillRule="nonzero"
          >
            <path d="M26.37,26l-8.795-12.822l0.015,0.012L25.52,4h-2.65l-6.46,7.48L11.28,4H4.33l8.211,11.971L12.54,15.97L3.88,26h2.65 l7.182-8.322L19.42,26H26.37z M10.23,6l12.34,18h-2.1L8.12,6H10.23z"></path>
          </g>
        </g>
      </g>
    </IconWrapper>
  </span>
);

export default memo(TwitterIcon);
